import React from 'react';
import TextArea from './TextArea';

class DurationTextArea extends TextArea {
  render() {
    const {
      value,
      isValid,
      isFocused,
      isTouched,
    } = this.state;
    const {
      classNames,
      isDisabled,
      errorMessage,
      noErrorState,
      isErrorTriggered,
    } = this.props;

    const isErrorState = (!noErrorState && !isValid && !isFocused && isTouched)
      || (!isValid && isErrorTriggered && !isFocused);

    let inputState = '';
    if (isDisabled) inputState = '--disabled';
    else if (isValid) inputState = '--valid';
    else if (isFocused) inputState = '--focused';
    else if (isErrorState) inputState = '--error';

    return (
      <div className={`duration-text-area${inputState} ${classNames}`}>
        <div className="duration-text-area-holder">{value}</div>
        <textarea
          readOnly={isDisabled}
          value={value}
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          className="duration-text-area__input"
          onChange={this.handleChange}
        />
        {isErrorState && (
          <div onClick={this.handleFocus} className="base-select__required duration-text-area__error">
            {errorMessage}
          </div>
        )}
      </div>
    );
  }
}

export default DurationTextArea;


// WEBPACK FOOTER //
// ./src/features/agent-coaching/DurationTextArea.js